import { SectionIcon } from './section-icon';
import { cn } from '@/shared/lib/cn';

export interface TitleProps {
  children?: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  sectionIcon?: React.ReactNode;
}

export function SectionHeader({ children, className, title, subtitle, sectionIcon }: TitleProps) {
  return (
    <div
      className={cn(
        'w-full flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between',
        className,
      )}
    >
      <div className="flex items-center gap-4 min-w-0">
        {sectionIcon && <SectionIcon icon={sectionIcon} />}

        <div className="flex flex-col gap-1 min-w-0">
          {title && (
            <span className="text-primary-active text-[1rem] font-bold truncate">{title}</span>
          )}
          {subtitle && <span className="text-primary text-[0.75rem]">{subtitle}</span>}
        </div>
      </div>

      <div className="flex gap-4 items-center">{children}</div>
    </div>
  );
}
